import React, { useMemo, useRef, useState, useEffect } from "react";
import { generatePath, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Carousel, Image } from "app/components";
import useConfig from "app/hooks/useConfig";
import {
  SectionTop,
  H2Div,
  H4Div,
  PDiv,
  SectionSecond,
  SectionThird,
  Fullwidth,
  SectionFour,
  SectionFive,
  FullwidthCarousel
} from "./styles";
import CardImage from "../../../../assets/images/cpgiftcard.png";
import Filmdose from "../../../../assets/images/Packshot_Filmdose_2019_Website.png";
import GiftCardMenu from "./GiftCardMenu";

const GiftcardInfo = ({ data, content }) => {
  const [t, i18n] = useTranslation();
  const {
    routes,
    // giftCardShop,
    giftCardShopEN,
    giftCardShopDE,
    country
  } = useConfig();

    console.log("🚀 ~ GiftcardInfo ~ country:", country)
  const [contentData, setContentData] = useState();

  const sliderPropsConfig = () => ({
    slidesToSlide: 1,
    responsive: {
      desktop: {
        breakpoint: {
          max: 30000,
          min: 992
        },
        items: 3
      },
      tablet: {
        breakpoint: {
          max: 992,
          min: 480
        },
        items: 2
      },
      mobile: {
        breakpoint: {
          max: 480,
          min: 0
        },
        items: 1
      }
    }
  });

  const sliderRef = useRef(null);
  const sliderProps = useMemo(() => sliderPropsConfig(), []);

  useEffect(() => {
    setContentData(content[0]);
  }, [content]);

  return (
    <div className="cinema-rent__technic-concession-wrapper">
      <div className="cinema-rent__technic-wrapper">
        <SectionTop>
          <H2Div>
            {i18n.language === "en" || i18n.language === "en-US"
              ? contentData?.headlineEN
              : contentData?.headline}
          </H2Div>
          <H4Div>
            {i18n.language === "en"
              ? contentData?.headline2EN
              : contentData?.headline2}
          </H4Div>
          <PDiv
            dangerouslySetInnerHTML={{
              __html:
                i18n.language === "en" || i18n.language === "en-US"
                  ? contentData?.descriptionEN
                  : contentData?.description
            }}
          />
        </SectionTop>
        <SectionSecond>
          <img src={contentData?.picture || CardImage} alt="giftcard_picture" />

          <div style={{ width: "100%", textAlign: "center" }} />

          {country !== "alb" ? (
            <>
              <a
                href={
                  i18n.language === "en" || i18n.language === "en-US"
                    ? giftCardShopEN
                    : giftCardShopDE
                }
                className="order_btn"
              >
                {t("common.order_giftcard")}
              </a>
              <p
                dangerouslySetInnerHTML={{
                  __html:
                    i18n.language === "en" || i18n.language === "en-US"
                      ? contentData?.description2EN
                      : contentData?.description2
                }}
              />
              {/* eslint-disable-next-line */}
              <a
                target="_blank"
                href={contentData?.pdfLink}
                className="gift_btn"
                rel="noopener noreferrer"
              >
                {i18n.language === "en" || i18n.language === "en-US"
                  ? contentData?.pdfDescriptionEN
                  : contentData?.pdfDescription}
              </a>
            </>
          ) : null}

        </SectionSecond>
            {country !== "alb" ? (
          <SectionThird>
              <H2Div>{t("common.gift_boxes")}</H2Div>
            <Fullwidth>
              <img src={contentData?.picture2 || Filmdose} alt="giftboxes" />
            </Fullwidth>
            <PDiv
            dangerouslySetInnerHTML={{
              __html:
              i18n.language === "en" || i18n.language === "en-US"
              ? contentData?.description3EN
              : contentData?.description3
            }}
            />
            {/* <GiftCardCoupon /> */}
          </SectionThird>
          ) : null}
        <SectionFour>
          <H2Div>{t("common.redeeming_cinemas")}</H2Div>
          <GiftCardMenu locations={data} />
        </SectionFour>
        {contentData?.competitions?.length > 0 && (
          <SectionFive>
            <FullwidthCarousel>
              <div
                className="et"
                style={{
                  width: "294px",
                  height: "49px",
                  fontSize: "20px",
                  letterSpacing: "1.5px",
                  marginLeft: "12px",
                  marginBottom: "-10px"
                }}
              >
                {t("common.giftcard_event_title")}
              </div>
              <Carousel
                {...sliderProps}
                refEl={sliderRef}
                className="cinema-rent__carousel giftCardSliderData"
              >
                {contentData?.competitions?.map(item => (
                  <NavLink
                    to={{
                      pathname: generatePath(routes.competitionDetail.pattern, {
                        id: item.id
                      })
                    }}
                  >
                    <div className="giftCardSlider" key={item?.id}>
                      <Image
                        src={item?.picture || item?.poster}
                        className="cinema-rent__carousel-image"
                      />
                      <h2>
                        {i18n.language === "en" || i18n.language === "en-US"
                          ? item?.headline1EN
                          : item?.headline1}
                      </h2>
                      <p
                        dangerouslySetInnerHTML={{
                          __html:
                            i18n.language === "en" || i18n.language === "en-US"
                              ? item?.shortDescriptionEN
                              : item?.shortDescription
                        }}
                      />
                    </div>
                  </NavLink>
                ))}
              </Carousel>
            </FullwidthCarousel>
          </SectionFive>
        )}
      </div>
    </div>
  );
};

export default GiftcardInfo;
